<template>
<div class="wrapper" :id="contrast">
  <Navbar @changeNavbar="changeNavFunction();" @changeNavbarDefDec="changeDefDec();"/>
  <div class="body-content" 
    :class="{ dashboard: $route.meta.dash === true }" 
    :style="navHeight ? 'padding-top:'+ navHeight+'px' : 'padding-top: 7rem'">
    <router-view/>
  </div>
  <Footer/>
</div>
</template>

<script>

import Navbar from './components/App/Navbar'; 
import Footer from './components/App/Footer';
import Swal from "sweetalert2";

export default {
  name: 'App',
  data() {
    return {
      tempo_restante: "",
      navHeight: null,
    }
  },
  computed: {
    queryParams() {
      return this.$route.query
    },
    contrast(){
      return this.$store.getters.getHighContrast;
    }
  },
  methods: {
    changeDefDec(){
      const navbar = document.querySelector('.appnavbar-container');
      this.navHeight = navbar.offsetHeight;
      setTimeout(()=>{
        const navbar = document.querySelector('.appnavbar-container');
        this.navHeight = navbar.offsetHeight;
      }, 400);
    },
    changeNavFunction(){
      const navbar = document.querySelector('.appnavbar-container');
      this.navHeight = navbar.offsetHeight;
    },

    async verifyExpirationToken() {
      // SO VAI ACONTECER SE O USUARIO TIVER TEMPO RESTANTE 
      if (this.$store.getters.getExpireCookieDate){
        var today = new Date();
        var expirationToken = new Date(this.$store.getters.getExpireCookieDate)
        var diff = expirationToken - today
        this.tempo_restante = (diff / 1000).toFixed(0)

        //SE O TEMPO RESTANTE FOR MENOS QUE 60 SEG
        if (this.tempo_restante < 60 && this.tempo_restante > 0){
          // E SE A NOTIFICACAO AINDA N FOI EXIBIDA, ELE A EXIBE
          if (!this.$store.getters.getIsAlreadyShowedExpNotyf) {
            const result = await Swal.fire({
              title: `Em ${this.tempo_restante} segundos sua sessão irá expirar!`,
              text: 'Se você ignorar ou fechar a mensagem, sua sessão irá encerrar e você perderá as modificações não salvas. Caso deseje continuar logado na plataforma, clique em "Manter Sessão".',
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              cancelButtonText: "Fechar mensagem",
              timer: (this.tempo_restante - 1) * 1000,
              timerProgressBar: true,
              confirmButtonText: "Manter Sessão",
            })

            //SE A PESSOA ESCOLHEU MANTER A SESSAO, CHAMA A ACTION REFRESHTOKEN
            if (result.isConfirmed) {
              await this.$store.dispatch('setRefreshToken')
            }

            //AO FINAL DA EXIBICAO DA NOTIFICACAO, INDICO QUE ELA JA FOI EXIBIDA
            this.$store.commit('setIsAlreadyShowedExpNotyf', true)
          }
        }

        //SE O TEMPO RESTANTE FOR MENOR OU IGUAL A 0 SEG ELE VAI DESLOGAR E REDIRECIONAR PRA HOME
        else if (this.tempo_restante <= 0){
          this.$cookies
            .keys()
            .forEach((cookie) => this.$cookies.remove(cookie));
          this.$store.commit('setIsLogged', false)
          this.$store.commit("setUserInfo", null);
          this.$store.commit('setExpireCookieDate', null)
          this.$store.commit('setIsAlreadyShowedExpNotyf', false)
          this.$router.push('/')
        }
      }

      //EXECUTANDO ESTE METODO RECURSIVAMENTE (FAZ ELE EXECUTAR A CADA 1 SEG)
      var self = this
      setTimeout(self.verifyExpirationToken, 1000)
    }
  },
  async created() { 
    this.$store.commit('setIsActiveModalLateralLogin', true)
    this.$store.commit('setIsActiveModalLateralSignUp', true)

    if (this.$cookies.get('accessToken')){
      await this.$store.dispatch('setVerifyToken')
      await this.$store.dispatch('setUserInfo')
      this.$store.commit('setIsAlreadyShowedExpNotyf', false)
    }
    else {
      this.$cookies
            .keys()
            .forEach((cookie) => this.$cookies.remove(cookie));
      this.$store.commit('setIsLogged', false)
      this.$store.commit("setUserInfo", null);
      this.$store.commit('setExpireCookieDate', null)
      this.$store.commit('setIsAlreadyShowedExpNotyf', false)
      //! clear vuex
    }    
  },
  mounted() {
    this.verifyExpirationToken() //INICIA A VERIFICACAO A CADA SEGUNDO DO TEMPO RESTANTE DA SESSAO
  },
  watch: {
    queryParams() {
        if (this.queryParams.emailconfirmed == 'true'){
          Swal.fire(
              'Conta confirmada!',
              'Sua conta foi confirmada com sucesso, você já pode fazer login.',
              'success'
          )
        }
        else if (this.queryParams.resendverificationemail == 'true'){
          Swal.fire(
              'Email de validação reenviado!',
              'O email de validação foi reenviado com sucesso, por favor, verifique sua caixa de entrada!',
              'success'
          )
        }
        else if (this.queryParams.invalidemailtoken == 'true'){
          Swal.fire(
              'Email de validação inválido!',
              'Este email de validação está inválido, por favor, reenvie o email de validação.',
              'error'
          )
        }
        else if (this.queryParams.invalidpasswordtoken == 'true'){
          Swal.fire(
              'Email de recuperação de senha inválido!',
              'Este email de recuperação de senha está inválido, por favor, refaça o pedido de recuperação.',
              'error'
          )
        }
        else if (this.queryParams.invaliduser == 'true'){
          Swal.fire(
              'Usuário inválido!',
              'Por favor, tente novamente.',
              'error'
          )
        }
    }
  },
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
@import './assets/css/uicons-regular-rounded.css';
@import './assets/css/uicons-solid-rounded.css';

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html{
  height: 100%;
  overflow-wrap: break-word;
 }

body {
  padding-right: 0 !important;
  font-family: 'Poppins', sans-serif;
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f2f2f2;
  /* background-image: linear-gradient(to bottom, #edf0f7, #e8ecf5, #e3e8f4, #dee5f2, #d9e1f0);
  background: linear-gradient(180deg, #F1F6F9 0%, #F1F6F9 50.52%, #D2E3EA 100%); */
}

h1{
  font-size: 4.209rem;
  font-weight: 800;
  margin-top: 0;
  padding: 0;
}

h2 {
  font-size: 3.157rem;
}

h3 {
  font-size: 2.375rem;
  }

h4 {
  font-size: 1.813rem;
  }

h5 {
  font-size: 1.375rem;
  }
/* Alguns textos não quebram automaticamente */
p{
  white-space: break-spaces !important;
  font-size: 1rem;
}
a{
  font-size: 1.063rem;
}
.wrapper{
	min-height: 100vh;
	position: relative;
}
.body-content{
  padding-top: 7rem;
  /** Altura do rodapé tem que ser igual a isso aqui e vice-versa **/
	padding-bottom: 5rem;
}

.ml-6 {
  margin-left: 6rem;
}

.boas-praticas h1{
  color: #41B3A3;
}

.materiais-documentos h1{
  color: #EB7071;
}

.certificacao h1{
  color: #F498C0;
}

.dados h1{
  color: #0d9f9f;
}

.grow { 
  transition: all .2s ease-in-out; 
}

.grow:hover { 
  transform: scale(1.035); 
}

.itens-modal {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.titulo-modal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2rem;
    font-size: 1.3rem;
    text-transform: uppercase;
    font-weight: bold;
    color:rgb(67, 70, 78);
}

.exit {
    cursor: pointer;
}

.select-personal,
.input-personal {
  border-radius: 8px;
  background: #FCFCFC;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.11);
  font-weight: lighter;
  padding: 0.2rem 0.4rem;
  box-shadow: 1px 2px 6px -3px rgba(0, 0, 0, 0.25);
}

.input-personal {
  padding: 0.2rem 0.4rem;
  font-size: 1.25rem;
}

.form-control, .input-personal {
  padding: 0.2rem 0.4rem;
  font-size: 0.938rem;
  font-weight: 400;
  border-radius: 8px;
  background: #FCFCFC;
  outline: none !important;
  border: 1px solid rgba(0, 0, 0, 0.11);
  font-weight: lighter;
  padding: 0.2rem 0.4rem;
  box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
}

.form-control:focus, .input-personal:focus {
  background: #FCFCFC;
  box-shadow: inset 0 -1px 0 #ddd;
  border: 1px solid rgba(0, 0, 0, 0.11);
  box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
}

.radio-personal {
  height: 18px;
  width: 18px;
}

.btn-router-link,
.btn-router-link:hover,
.btn-router-link:focus {
  text-decoration: none;
}

.cool-link {
    display: inline-block;
}

.cool-link::after {
    content: '';
    display: block;
    width: 0;
    height: 0.1rem;
    background-color: #252525;
    transition: width .4s;
    margin-top: 0.1rem;
}

.cool-link:hover::after {
    width: 100%;
    transition: width .4s;
}

.error-input {
  color: #ff0000;
  background-color: #fff;
  border-color: #ec1111;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(255 0 0 / 25%);
}

a:hover {
  text-decoration: none;
}

.box-lista {
  background-color: #FCFCFC;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.11);
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  min-height: 15vh;
  margin: 1rem 3rem;
  padding: 0.4rem;
  transition: all ease-in-out 0.3s;
}

.img-info-box-lista {
  width: auto;
  max-height: 72px;
  margin: 0.2rem;
}

.third-info-box-lista {
  color: #676BD6;
  cursor: pointer;
  user-select: none;
  font-weight: 500;   
}

.last-info-box-lista {
  color: #EB3E3E;
  cursor: pointer;
  user-select: none;
  transition: all ease 0.3s;
  font-weight: 500;
  text-align: right;
}

.title-style-box-lista{
  font-size: 1.563rem;
  color: #656565;
  margin: 0;
  text-align: center;
  font-weight: 500;
}

@media screen and (max-width: 992px) {
    table{
        width: 45vw;
    }
    h1{
      font-size: 3rem;
    }
 } 

 @media screen and (max-width: 576px) {
    .form-group{
      display: block!important;
    }
 } 

/* Shadows */
/* //Elev1 */
.shadow-elev1{
  box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
}
/* //Elev2 */
.shadow-elev2{
  box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
}
/* //Elev3 */
.shadow-elev3{
  box-shadow: 0px 8px 18px -6px rgba(24, 39, 75, 0.12), 0px 12px 42px -4px rgba(24, 39, 75, 0.12);
}
/* //Elev4 */
.shadow-elev4{
  box-shadow: 0px 8px 22px -6px rgba(24, 39, 75, 0.12), 0px 14px 64px -4px rgba(24, 39, 75, 0.12);
}
/* //Elev5 */
.shadow-elev5{
  box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14);
}


/* ----------------------------- ACCESSIBILITY: HIGH CONTRAST STYLE -------------------------------------- */
#high-contrast, #high-contrast .card-section, #high-contrast .acessibility-section{
  background: black;
}


/* --- A --- */
#high-contrast a div:first-child {
  background-color: transparent;
}

#high-contrast a > div{
  border: 4px #feb979 solid;
}

#high-contrast a::before{
  color: #ff0;
}


/* --- Buttons --- */
#high-contrast button{
  background-color: black!important;;
  border: #feb979 3px solid!important;
}

#high-contrast button, #high-contrast button span, #high-contrast button p{
  color: white!important;
}

#high-contrast button > div{
  background-color: transparent;
}


/* --- Table th,tr --- */
#high-contrast tr{
  background-color: black;
  border: rgb(211, 211, 211) 4px solid;
  color: white;
}

#high-contrast tr:first-child{
  background-color: rgb(211, 211, 211);
  color: black;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

#high-contrast tr:first-child th{
  background-color: rgb(211, 211, 211);
  color: black;
}

#high-contrast tr:first-child span{
  color: black!important;;
}

#high-contrast td > div{
  background-color: transparent;
  border: #feb979 2px solid;
}


/* --- Modal --- */
#high-contrast .modal-content, #high-contrast .modal-body > div, #high-contrast .modal-content .container{
  background-color: rgb(68, 68, 68);
  color: white;
}


/* --- Input checkbox --- */
#high-contrast label::before{
  border-color: white;
}

#high-contrast .used-line{
  background-color: #4e4e4e!important;
}

#high-contrast input[type=checkbox] + label:before {
    border-color:#fff;
}

#high-contrast input[type=checkbox]:checked + label:before {
    background-color: rgb(192, 192, 192);
}

#high-contrast input[type=checkbox]:disabled + label:before {
    border-color: rgb(100, 100, 100);
}

#high-contrast input[type=checkbox]:checked:disabled + label:before {
    background-color: rgb(192, 192, 192);
    border-color: rgb(100, 100, 100);
}


/* --- Text tags --- */
#high-contrast h1, #high-contrast h2, #high-contrast h3,
#high-contrast h4, #high-contrast h5, #high-contrast h6,
#high-contrast p, #high-contrast label,
#high-contrast strong, #high-contrast em, #high-contrast cite,
#high-contrast q, #high-contrast b, #high-contrast u,
#high-contrast span,
#high-contrast .button-back{
  color: white !important;
}

#high-contrast h1, #high-contrast h2, #high-contrast h3,
#high-contrast h4, #high-contrast h5, #high-contrast h6{
  text-decoration: underline;
}


/* --- Icons --- */
#high-contrast button i{
  text-decoration: none;
}


/* --- Navbar --- */
#high-contrast .navbar{
  background-color: black;
  background-image: none;
  border-bottom: 2px white solid; 
  /* 9af4c */
}


/* --- Footer --- */
#high-contrast .bg-rodape{
  border-top: 2px white solid;
  background-color: black;
}


/* --- Materiais e Documentos --- */
#high-contrast div> .box-style{
  background-color: black;
  border: white 2px solid;
}

#high-contrast div> .box-style i{
  color: white;
}

#high-contrast div> .box-style div:has(i):first-child {
  padding: 0.25rem;
  border: #feb979 2px solid;
  border-radius:6px;
}

.dashboard{
  background-color: white;
}
</style> 